import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { AppShell } from './components/layout/AppShell';
import LoginPage from './features/auth/LoginPage';
import { useSession } from './lib/hooks';
import DashboardPage from './features/dashboard/DashboardPage';
import TourPage from '@/features/tour/TourPage';
import AlertsPage from './features/alerts/AlertsPage';
import RecommendationsPage from './features/recommendations/RecommendationsPage';
import OrdersPage from './features/orders/OrdersPage';
import InventoryPage from './features/inventory/InventoryPage';
import CombosPage from './features/combos/CombosPage';
import UnmetDemandPage from './features/unmet-demand/UnmetDemandPage';
import ForecastPage from './features/forecast/ForecastPage';
import ExternalFactorsPage from './features/external-factors/ExternalFactorsPage';
import SettingsPage from './features/settings/SettingsPage';
// Lazy: se lleva marked + el markdown del plan, y solo hace falta si entrás a /plan.
const PlanPage = lazy(() => import('./features/plan/PlanPage'));
// Ídem: se lleva SheetJS (~400 kB), que solo se usa al importar el histórico del ERP.
const ImportPage = lazy(() => import('./features/import/ImportPage'));

export function App() {
  const session = useSession();

  if (session.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center gap-2 bg-canvas text-ink-muted">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span className="text-sm">Cargando…</span>
      </div>
    );
  }

  // El gate real está en el server (app.ts gatea /api/*); esto es la puerta visible. Si la
  // sesión no existe o expiró, no se monta ninguna pantalla con datos del cliente.
  if (!session.data?.authed) return <LoginPage />;

  return (
    <AppShell>
      {/* Un solo Suspense para las páginas lazy (plan, importar). */}
      <Suspense
        fallback={
          <div className="flex items-center justify-center gap-2 py-20 text-ink-muted">
            <Loader2 className="h-5 w-5 animate-spin" />
            <span className="text-sm">Cargando…</span>
          </div>
        }
      >
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/recorrido" element={<TourPage />} />
        <Route path="/alertas" element={<AlertsPage />} />
        <Route path="/recomendaciones" element={<RecommendationsPage />} />
        <Route path="/ordenes" element={<OrdersPage />} />
        <Route path="/inventario" element={<InventoryPage />} />
        <Route path="/combos" element={<CombosPage />} />
        <Route path="/demanda" element={<UnmetDemandPage />} />
        <Route path="/importar" element={<ImportPage />} />
        <Route path="/forecast" element={<ForecastPage />} />
        <Route path="/factores" element={<ExternalFactorsPage />} />
        <Route path="/plan" element={<PlanPage />} />
        <Route path="/configuracion" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Suspense>
    </AppShell>
  );
}
